import React, { useState } from 'react';
import { Card, FullCard, Spinner, Button} from '../components/CommonComponents';
import SpinnerButton from '../components/spinnerButton';
import { FileUpload} from '../components/Fileupload';
import { informationExtractionGetKeys, informationExtractionGetValues} from '../api/serverAPI';
import { download } from "../utils";
import { pdfjs, Document, Page } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

export const InformationExtraction = () => {
    const [selectedFiles, setSelectedFiles] = useState(null);
    const [progress, setProgress] = useState(0);
    const [loading, setLoading] = useState(false);
    const [base64Data, setBase64Data] = useState(null);
    const [error, setError] = useState(null);
    const [generateqaData, setGenerateqaData] = useState();
    const [compare, setCompare] = useState(false)
    const [numPages, setNumPages] = useState();
    const [pageNumber, setPageNumber] = useState(1);
    const [getKeys, setGetKeys] = useState();
    const [showUpload, setShowUpload] = useState(false);

    const handleUploadClick = () => {
        setGetKeys(null);

        setShowUpload(true);

        console.log("All", getKeys, generateqaData, showUpload)
    };

    const [file, setFile] = useState(null);
    // const [numPages, setNumPages] = useState(null);
    // const [pageNumber, setPageNumber] = useState(1);
    const [forFormData, setForFormData] = useState();

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        setGenerateqaData()
        setSelectedFiles(file);
        setFile(file);

        const formData = new FormData();
        formData.append('file', file);
        setForFormData(formData);

        const reader = new FileReader();
        reader.onload = () => {
            const base64String = reader.result.split(",")[1]; // Extract the Base64 data part
            setBase64Data(base64String);
        };
        reader.readAsDataURL(file);

        const interval = setInterval(() => {
            setProgress((prevProgress) => {
                if (prevProgress < 100) {
                    return prevProgress + 10;
                } else {
                    clearInterval(interval);

                    return prevProgress;
                }
            });
        }, 1000);
    };

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
    }

    const goToNextPage = () => {
        if (pageNumber < numPages) {
            setPageNumber(pageNumber + 1);
        }
    };

    const goToPreviousPage = () => {
        if (pageNumber > 1) {
            setPageNumber(pageNumber - 1);
        }
    };

    const DisplayOutput = () => {
        const containerStyle = {
            padding: '20px'
        };

        const overlayStyle = {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            backgroundColor: 'rgba(0, 0, 0, 0.5)'
        };

        const largeTableStyle = {
            borderCollapse: 'collapse',
            width: '100%',
            marginBottom: '20px'
        };

        const largeTableCellStyle = {
            border: '1px solid #ddd',
            padding: '8px',
            verticalAlign: 'top'
        };

        const largeTableHeaderStyle = {
            border: '1px solid #ddd',
            padding: '8px',
            backgroundColor: '#f2f2f2',
            textAlign: 'left'
        };

        const smallTableStyle = {
            borderCollapse: 'collapse',
            width: '100%',
            marginBottom: '10px'
        };

        const smallTableCellStyle = {
            border: '1px solid #ddd',
            padding: '4px'
        };

        const tableHeaderStyle = {
            backgroundColor: '#f2f2f2',
            ...smallTableCellStyle
        };

        if (loading) {
            return (
                <div style={overlayStyle}>
                    <Spinner />
                </div>
            );
        }

        if (!generateqaData) {
            return null; // No data available
        }

        const renderSmallTable = (data) => {
            if (data === undefined || data === null) {
                return null;
            }

            return (
                <table style={smallTableStyle}>
                    <tbody>
                        {Object.entries(data).map(([key, value]) => (
                            <tr key={key}>
                                <td style={smallTableCellStyle}><strong>{key}:</strong></td>
                                <td style={smallTableCellStyle}>
                                    {typeof value === 'object' && value !== null
                                        ? renderSmallTable(value)
                                        : String(value)}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            );
        };
        const renderTableContent = (key, value) => {
            if (value === null || value === undefined) {
                return null;
            }

            // Handle arrays
            if (Array.isArray(value)) {
                if (value.length === 0) {
                    return null;
                }

                return (
                    <div key={key}>
                        {/* <div style={{ marginBottom: '10px' }}>
                            <hr style={{ margin: '10px 0' }} />
                        </div> */}
                        <div>
                            {/* <strong>{key}</strong> */}
                            <div style={{ marginTop: '10px' }}>
                                {value.map((item, index) => (
                                    <div key={index} style={{ marginBottom: '10px' }}>
                                        {/* If item is an object, recursively render its content */}
                                        {typeof item === 'object' ? (
                                            renderTableContent(`${key} ${index + 1}`, item)
                                        ) : (
                                            <div>{item}</div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                );
            }

            // Handle objects
            if (typeof value === 'object') {
                return (
                    <div key={key}>
                        <div style={{ marginBottom: '10px' }}>
                            <hr style={{ margin: '10px 0' }} />
                        </div>
                        <div>
                            <strong>{key}</strong>
                            <div style={{ marginTop: '10px' }}>
                                {Object.entries(value).map(([subKey, subValue]) => (
                                    <div key={subKey} style={{ marginBottom: '10px' }}>
                                        {/* Recursively render sub-objects */}
                                        {typeof subValue === 'object' ? (
                                            renderTableContent(subKey, subValue)
                                        ) : (
                                            <div style={{ display: 'flex', marginBottom: '5px' }}>
                                                <strong style={{ width: '150px' }}>{subKey}:</strong>
                                                <span>{subValue === null || subValue === undefined ? "" : String(subValue)}</span>
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                );
            }

            // Handle primitive values (strings, numbers, booleans)
            return (
                <div key={key}>
                    {/* <div style={{ marginBottom: '10px' }}>
                        <hr style={{ margin: '10px 0' }} />
                    </div> */}
                    <div>
                        {/* <strong>{key}</strong> */}
                        <div style={{ marginTop: '10px' }}>
                            <p>{value === null || value === undefined ? "" : String(value)}</p>
                        </div>
                    </div>
                </div>
            );
        };




        return (
            <div className="">
                <Card>
                    <div className="subheading text-center">
                        Here Is Your Extracted document
                    </div>
                    <div className="my-6">
                        <div className="border-2 border-[#23479F] rounded-lg">
                            <div className="bg-[#23479F] p-4">
                                <div class="grid grid-cols-2 gap-4">
                                    <p className="text-white mt-1">
                                        {selectedFiles && (
                                            <div className='mx-1 line-clamp-1'>
                                                {selectedFiles.name}
                                            </div>
                                        )}
                                    </p>
                                    <div className="flex flex-nowrap justify-end gap-3">
                                        <div>
                                            <Button size="white" onClick={download}>Download</Button>
                                        </div>
                                        <div>
                                            <Button size="white" onClick={() => setCompare(true)}>Compare</Button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="bg-white mx-auto rounded-lg">
                                <div style={containerStyle} id='page-container'>
                                    <table style={largeTableStyle}>
                                        <tbody>
                                            {console.log(generateqaData, "gen")}
                                            {Object.entries(generateqaData).map(([key, value]) => (
                                                <React.Fragment key={key}>
                                                    <tr>
                                                        <td style={largeTableHeaderStyle}>
                                                            <strong>{key}</strong>
                                                        </td>
                                                        <td style={largeTableCellStyle} colSpan={1}>
                                                            <div style={{ marginBottom: '10px' }}>
                                                                {renderTableContent(key, value)}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colSpan={2} style={largeTableCellStyle}>
                                                        </td>
                                                    </tr>
                                                </React.Fragment>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </Card>
            </div>

        );
    };



    const GetKeys = () => {
        setLoading(true);
        informationExtractionGetKeys(forFormData
        ).then((response) => {
            const data = response.data.keys;
            console.log(data);
            setGetKeys(data);
            setLoading(false);
        }).catch((error) => {
            console.error("Failed to fetch user details:", error);
            setError(error);
        });
    };

    const handleParentCheckboxChange = (parentKey, value) => {
        setGetKeys(prevData => {
            const updatedData = { ...prevData };

            if (Array.isArray(updatedData[parentKey])) {
                updatedData[parentKey] = updatedData[parentKey].map(item => {
                    if (typeof item === 'object') {
                        return Object.keys(item).reduce((acc, key) => {
                            acc[key] = Array.isArray(item[key])
                                ? item[key].map(() => value)
                                : value;
                            return acc;
                        }, {});
                    }
                    return value;
                });
            } else if (typeof updatedData[parentKey] === 'object') {
                Object.keys(updatedData[parentKey]).forEach(key => {
                    updatedData[parentKey][key] = value;
                });
            }

            return updatedData;
        });
    };

    const handleChildCheckboxChange = (parentKey, childKey, index = null, value) => {
        setGetKeys(prevData => {
            const updatedData = { ...prevData };
            if (Array.isArray(updatedData[parentKey])) {
                updatedData[parentKey] = updatedData[parentKey].map((item, i) => {
                    if (i === index && typeof item === 'object') {
                        return {
                            ...item,
                            [childKey]: value,
                        };
                    }
                    return item;
                });
            } else if (typeof updatedData[parentKey] === 'object') {
                if (updatedData[parentKey][childKey] !== undefined) {
                    updatedData[parentKey][childKey] = value;
                }
            }
            return updatedData;
        });
    };

    const renderCheckbox = (key, value, parentKey = null, index = null) => (
        <div key={key} style={{ marginLeft: parentKey ? '20px' : '0px' }}>
            <label>
                <input
                    type="checkbox"
                    checked={value}
                    onChange={() => parentKey
                        ? handleChildCheckboxChange(parentKey, key, index, !value)
                        : handleParentCheckboxChange(key, !value)}
                />
                {key}
            </label>
        </div>
    );

    const renderSection = (sectionKey, sectionValue) => {
        const isPrimitive = typeof sectionValue === 'boolean';

        if (isPrimitive) {
            return (
                <div key={sectionKey}>
                    <h3>
                        <label>
                            <input
                                type="checkbox"
                                checked={sectionValue}
                                onChange={() => handleParentCheckboxChange(sectionKey, !sectionValue)}
                            />
                            {sectionKey}
                        </label>
                    </h3>
                </div>
            );
        }

        if (Array.isArray(sectionValue)) {
            const isChecked = sectionValue.every(item =>
                typeof item === 'object'
                    ? Object.values(item).every(val => val === true || (Array.isArray(val) && val.every(v => v === true)))
                    : item === true
            );
            return (
                <div key={sectionKey}>
                    <h3>
                        <label>
                            <input
                                type="checkbox"
                                checked={isChecked}
                                onChange={() => handleParentCheckboxChange(sectionKey, !isChecked)}
                            />
                            {sectionKey}
                        </label>
                    </h3>
                    <div style={{ marginLeft: '20px' }}>
                        {sectionValue.map((item, index) => (
                            <div key={index}>
                                {index > 0 && <br />}
                                {typeof item === 'object'
                                    ? Object.keys(item).map(key => renderSection(key, item[key]))
                                    : renderCheckbox(item, sectionKey, index)}
                            </div>
                        ))}
                    </div>
                </div>
            );
        } else {
            const isChecked = Object.values(sectionValue).every(value =>
                value === true || (Array.isArray(value) && value.every(v => v === true))
            );
            return (
                <div key={sectionKey}>
                    <h3>
                        <label>
                            <input
                                type="checkbox"
                                checked={isChecked}
                                onChange={() => handleParentCheckboxChange(sectionKey, !isChecked)}
                            />
                            {sectionKey}
                        </label>
                    </h3>
                    <div style={{ marginLeft: '20px' }}>
                        {Object.keys(sectionValue).map(key => (
                            <div key={key}>
                                {typeof sectionValue[key] === 'object'
                                    ? renderSection(key, sectionValue[key])
                                    : renderCheckbox(key, sectionValue[key], sectionKey)}
                            </div>
                        ))}
                    </div>
                </div>
            );
        }
    };

    const RecursiveList = ({ data, checkedItems, setCheckedItems, path = '', orgobj, setupdatedpayload }) => {
        const handleCheckboxChange = (currentPath, isChecked) => {
            const newCheckedItems = { ...checkedItems };

            const toggleChildren = (children, checked, basePath) => {
                for (const childKey in children) {
                    if (children.hasOwnProperty(childKey)) {
                        const childPath = `${basePath}/${childKey}`;
                        newCheckedItems[childPath] = checked;

                        if (typeof children[childKey] === 'object' && children[childKey] !== null) {
                            toggleChildren(children[childKey], checked, childPath);
                        }
                    }
                }
            };

            newCheckedItems[currentPath] = isChecked;

            const currentData = data[currentPath.split('/').pop()];
            if (typeof currentData === 'object' && currentData !== null) {
                toggleChildren(currentData, isChecked, currentPath);
            }

            setCheckedItems(newCheckedItems);
        };




        if (orgobj) {
            // console.log(checkedItems,orgobj)

            const deepClone = (obj) => {
                return JSON.parse(JSON.stringify(obj));
            };
            const json = deepClone(orgobj);

            // Object with paths and values
            const updates = checkedItems;

            // Function to update JSON based on the path and conditions
            function updateJsonByPath(json, path, value) {
                const keys = path.split("/");  // Split the path by '/'
                let current = json;  // Reference to the current level in the JSON object

                // Traverse the JSON until the second last key
                for (let i = 0; i < keys.length - 1; i++) {
                    if (!current[keys[i]]) {
                        return;  // Stop if the path doesn't exist
                    }
                    current = current[keys[i]];
                }

                // Update the final key's value only if it is `false`
                const lastKey = keys[keys.length - 1];
                if (current.hasOwnProperty(lastKey) && current[lastKey] === false) {
                    current[lastKey] = value;
                }
            }

            // Apply the updates from the object
            Object.keys(updates).forEach(path => {
                updateJsonByPath(json, path, updates[path]);
            });

            console.log('inputtt', json)

            sessionStorage.setItem('keys',JSON.stringify(json))
            // setupdatedpayload(json)
            


        }

     



        return (
            <ul style={{ listStyleType: 'none', padding: 0 }}>
                {Object.keys(data).map((key, index) => {
                    const currentPath = path ? `${path}/${key}` : key;
                    const isChecked = checkedItems[currentPath] || false;

                    return (
                        <li key={index} style={{ margin: '5px 0', paddingLeft: `${path.split('/').length * 20}px` }}>
                            <label>
                                <input
                                    type="checkbox"
                                    checked={isChecked}
                                    onChange={(e) => handleCheckboxChange(currentPath, e.target.checked)}
                                />
                                {key}
                            </label>
                            {typeof data[key] === 'object' && data[key] !== null && !Array.isArray(data[key]) && (
                                <RecursiveList
                                    data={data[key]}
                                    checkedItems={checkedItems}
                                    setCheckedItems={setCheckedItems}
                                    path={currentPath}
                                />
                            )}
                            {Array.isArray(data[key]) && data[key].length > 0 && (
                                <ul>
                                    {data[key].map((item, idx) => (
                                        <li key={idx}>
                                            <RecursiveList
                                                data={item}
                                                checkedItems={checkedItems}
                                                setCheckedItems={setCheckedItems}
                                                path={`${currentPath}/${idx}`}
                                            />
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </li>
                    );
                })}
            </ul>
        );


    };



    const GetValues = () => {
        setLoading(true);
        informationExtractionGetValues(JSON.parse(sessionStorage.getItem('keys'))).then((response) => {
            const data = response.data;
            console.log(data);
            setGenerateqaData(data);
            setLoading(false);
        }).catch((error) => {
            console.error("Failed to fetch user details:", error);
            setError(error);
        });
    };

    const [checkedItems, setCheckedItems] = useState({});
    const [updatedpayload, setupdatedpayload] = useState({});
    const [selectAll, setSelectAll] = useState(false);

    const handleSelectAllChange = (isChecked) => {
        setSelectAll(isChecked); // Update the "Select All" state
    
        const newCheckedItems = {};
        const toggleAllChildren = (data, basePath = '') => {
            Object.keys(data).forEach((key) => {
                const currentPath = basePath ? `${basePath}/${key}` : key;
                newCheckedItems[currentPath] = isChecked; // Set all to the value of isChecked
    
                if (typeof data[key] === 'object' && data[key] !== null) {
                    toggleAllChildren(data[key], currentPath); // Recursively check/uncheck all children
                } else if (Array.isArray(data[key])) {
                    data[key].forEach((_, index) => {
                        newCheckedItems[`${currentPath}/${index}`] = isChecked;
                    });
                }
            });
        };
    
        toggleAllChildren(getKeys); // Apply the toggle function to the `getKeys` data
    
        setCheckedItems(newCheckedItems); // Set the new state of all checked items
    };
    

    return (
        <>
            {(compare) && (file) && (
                <div className='z-50 grid-cols-2 gap-5 p-5 border-black rounded-md border-solid border-2 absolute top-0 flex inset-0 m-auto w-11/12 h-5/6 bg-white'>
                    <button
                        className="hover:bg-gray-300 absolute top-0 right-1 text-xl"
                        onClick={() => setCompare(false)}
                    >
                        &times;
                    </button>
                    <div className="h-full w-full overflow-y-auto">
                        <div className="border-2 border-[#23479F] rounded-lg">
                            <div className="bg-[#23479F] p-4">
                                <p className='text-white text-center mt-1'>
                                    Original Document
                                </p>
                            </div>
                            <div className="bg-white mx-auto rounded-lg">
                                <div className="overflow-x-auto overflow-y-auto">
                                    <Document file={file} onLoadSuccess={onDocumentLoadSuccess}>
                                        <Page className="p-4" pageNumber={pageNumber} />
                                    </Document>
                                    <div className="p-1 flex justify-center space-x-2 mt-2">
                                        <button className='text-sm text-white rounded-lg bg-sky-800 p-1' onClick={goToPreviousPage} disabled={pageNumber <= 1}>Prev</button>
                                        <span>Page {pageNumber} of {numPages}</span>
                                        <button className='text-sm text-white rounded-lg bg-sky-800 p-1' onClick={goToNextPage} disabled={pageNumber >= numPages}>Next</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="h-full w-full overflow-y-auto">
                        <div className="border-2 border-[#23479F] rounded-lg">
                            <div className="bg-[#23479F] p-4">
                                <p className='text-white text-center mt-1'>
                                    Extracted Document
                                </p>
                            </div>
                            <div className="bg-white mx-auto rounded-lg">
                                <DisplayOutput />
                            </div>
                        </div>
                    </div>
                </div>
            )}
    
            <div className="flex gap-4 overflow-y-hidden">
                <div className="secondcardWidth">
                    <FullCard>
                        {progress === 100 && getKeys ? (
                            <div>
                                <div className="flex mb-4">
                                    <a
                                        style={{ color: '#6a0dad' }}
                                        className="hover:underline cursor-pointer"
                                        onClick={handleUploadClick}
                                    >
                                        ← Back to Upload
                                    </a>
                                </div>
                                <div className="flex items-center justify-between bg-blue rounded-t-lg p-2">
                                    <div id="textpara">
                                        <p className="text-white flex-grow text-center">
                                            Select Keys
                                        </p>
                                    </div>
                                    <div id="submitbutton" onClick={GetValues} >
                                        <Button size="extrasmall">
                                            Submit
                                        </Button>
                                    </div>
                                </div>
                                <div className="border-2 border-[#23479F] rounded-b-lg p-2" style={{ maxHeight: '67vh', overflowY: 'auto' }}>
                                    {/* Add "Select All" checkbox here */}
                                    <div>
                                        <label>
                                            <input
                                                type="checkbox"
                                                checked={selectAll}
                                                onChange={(e) => handleSelectAllChange(e.target.checked)}
                                            />
                                            Select All
                                        </label>
                                    </div>
    
                                    {/* Recursive List to Render All Checkboxes */}
                                    <RecursiveList
                                        data={getKeys}
                                        checkedItems={checkedItems}
                                        setCheckedItems={setCheckedItems}
                                        orgobj={getKeys}
                                        setupdatedpayload={setupdatedpayload}
                                    />
                                </div>
                            </div>
                        ) : (
                            <div>
                                <div className="subheading text-center mt-2">
                                    Information Extraction
                                </div>
                                <div className="text-center">
                                    <div className="my-8">
                                        <div className="items-center">
                                            <FileUpload accept={"application/pdf"} onChange={handleFileChange} />
                                        </div>
                                    </div>
                                    <div className="mt-4">
                                        {selectedFiles && (
                                            <div>
                                                <b>File Name: </b>
                                                {selectedFiles.name}
                                            </div>
                                        )}
                                        {progress > 0 && progress < 100 && (
                                            <div className="my-4">
                                                <div className="bg-[#D2CFF1] h-4 rounded-full">
                                                    <div className="bg-[#23479F] h-full rounded-full" style={{ width: `${progress}%` }}></div>
                                                </div>
                                                <div className="text-center mt-2">{`${progress}% Complete`}</div>
                                            </div>
                                        )}
                                    </div>
                                    {progress === 100 && !getKeys && (
                                        <>
                                            <div className="flex justify-center my-8">
                                                <Button
                                                    size="medium"
                                                    color="light-purple"
                                                    type="submit"
                                                    onClick={GetKeys}
                                                    disabled={loading} // Disable the button if loading
                                                >
                                                    {loading ? <SpinnerButton size='sm' colour='white' /> : "Get Tags"}
                                                </Button>
                                            </div>
                                            {error && (
                                                <div className="text-red-500">
                                                    {'An error occurred. Please try again.'}
                                                </div>
                                            )}
                                        </>
                                    )}
                                </div>
                            </div>
                        )}
                    </FullCard>
                </div>
                <div className="thirdcardWidth overflow-y-auto h-[90vh]">
                    {generateqaData && (
                        <Card>
                            <DisplayOutput />
                        </Card>
                    )}
                </div>
            </div>
        </>
    );
};

export default InformationExtraction;